import dashboard from "./modules/dashboard";
import BasicLayout from "@/layouts/basic-layout";

import orderManagement from "./modules/orderManagement";
import userOrganizations from "./modules/userOrganizations";
import commonPhrases from "./modules/commonPhrases";
import hotlineMonitor from "./modules/hotlineMonitor";
import business from "./modules/business";
import notice from "./modules/notice";
import knowledgeBase from "./modules/knowledgeBase";
import maxKb from "./modules/maxKb";
import bpm from "./modules/bpm";
import trainExamManager from "./modules/trainExamManager";
import performanceManagement from "./modules/performanceManagement";
import house from "./modules/house";
import resident from "./modules/resident";
import merchant from "./modules/merchant";
import grid from "./modules/grid";
import home from "./modules/home";
import patrol from "./modules/patrol";
import suggestCollect from "./modules/suggestCollect";
import suggestReply from "./modules/suggestReply";
import party from "./modules/party";
import cityOrder from "./modules/cityOrder";
import reportTable from "./modules/reportTable";
import volunteer from "./modules/volunteer";
import enterprise from "./modules/enterprise";
import orderAnalysis from "./modules/orderAnalysis";
import statement from "./modules/statement";
import point from "./modules/point";
import society from "./modules/society";
import peopleLivelihood from "./modules/peopleLivelihood";
import digitalBoard from "./modules/digitalBoard";

const meta = {
  auth: false,
  cache: false,
};
/**
 * 在主框架内显示
 */

const frameIn = [
  {
    path: "/",
    name: "home",
    redirect: {
      name: "dashboard-console",
    },
    component: BasicLayout,
    children: [
      {
        path: "index",
        name: "index",
        redirect: {
          name: "dashboard-console",
        },
      },
      {
        path: "orgselect",
        name: "orgSelect",
        component: () => import("@/components/org-select"),
      },
      {
        path: "log",
        name: "log",
        meta: {
          title: "前端日志",
          auth: false,
        },
        component: () => import("@/pages/system/log"),
      },
      // 刷新页面 必须保留
      {
        path: "refresh",
        name: "refresh",
        hidden: true,
        component: {
          beforeRouteEnter(to, from, next) {
            next((instance) => instance.$router.replace(from.fullPath));
          },
          render: (h) => h(),
        },
      },
      // 页面重定向 必须保留
      {
        path: "redirect/:route*",
        name: "redirect",
        hidden: true,
        component: {
          beforeRouteEnter(to, from, next) {
            next((instance) =>
              instance.$router.replace(JSON.parse(from.params.route)),
            );
          },
          render: (h) => h(),
        },
      },
    ],
  },
  dashboard,
  orderManagement,
  userOrganizations,
  commonPhrases,
  business,
  hotlineMonitor,
  notice,
  patrol,
  knowledgeBase,
  maxKb,
  bpm,
  trainExamManager,
  performanceManagement,
  house,
  resident,
  merchant,
  grid,
  home,
  suggestCollect,
  suggestReply,
  party,
  cityOrder,
  reportTable,
  volunteer,
  enterprise,
  orderAnalysis,
  statement,
  point,
  society,
  peopleLivelihood,
  digitalBoard,
];

/**
 * 在主框架之外显示
 */

const frameOut = [
  // 登录
  {
    path: "/login",
    name: "login",
    meta: {
      title: "登录",
    },
    component: () => import("@/pages/account/login"),
    beforeEnter: (to, from, next) => {
      next();
    },
  },
  // 注册
  {
    path: "/register",
    name: "register",
    meta: {
      title: "注册",
    },
    component: () => import("@/pages/account/register"),
  },
  // 注册结果
  {
    path: "/register/result",
    name: "register-result",
    meta: {
      auth: true,
      title: "注册结果",
    },
    component: () => import("@/pages/account/register/result"),
  },
  // 应用下载界面
  {
    path: "/downloadApp",
    name: "downloadApp",
    meta: {
      // auth: true,
      title: "应用下载",
    },
    component: () => import("@/pages/account/downloadApp"),
  },
  {
    path: "/downloadAppOnPhone",
    name: "downloadAppOnPhone",
    meta: {
      // auth: true,
      title: "应用下载",
    },
    component: () => import("@/pages/account/downloadAppOnPhone"),
  },
  //重置密码
  {
    path: "/resetpassword",
    name: "resetpassword",
    meta: {
      // auth: true,
      title: "重置密码",
    },
    component: () => import("@/pages/account/resetpassword"),
  },
  //重置成功页
  {
    path: "/resetpassword/result",
    name: "resetpasswordSuccess",
    meta: {
      // auth: true,
      title: "重置密码成功",
    },
    component: () => import("@/pages/account/resetpassword/result"),
  },
  // 详情组件用户信息展示
  {
    path: "/user/details/:id",
    name: "userDetails",
    meta: {
      title: "测试界面",
    },
    component: () => import("@/pages/dashboard/user/userAbDetails.vue"),
  },

  // 测试界面
  {
    path: "/test",
    name: "test",
    meta: {
      title: "测试界面",
    },
    component: () => import("@/components/ab-cust-dialog/test.vue"),
  },
  //注销用户成功
  {
    path: "/logoffSuccss",
    name: "logoffSuccess",
    meta: {
      title: "注销用户成功",
    },
    component: () => import("@/pages/dashboard/user/reset"),
  },

  // 重置密码
  {
    path: "/updatePwd/:username/:password",
    name: "updatePwd",
    meta: {
      title: "重置密码",
    },
    component: () => import("@/pages/account/updatePwd"),
  },

  /* start * 在新窗口打开的页面 *** 12345热线工单系统 ************************************************/
  {
    path: "/orderManagement/todoOrder/toHandOutHandle",
    name: "toHandOutHandle",
    meta: {
      title: "待派发-处理",
    },
    component: () =>
      import("@/pages/orderManagement/todoOrder/toHandOutHandle.vue"),
  },
  {
    path: "/orderManagement/history",
    name: "history",
    meta: {
      title: "历史工单",
    },
    component: () =>
      import("@/pages/orderManagement/createOrder/historyOrder.vue"),
  },
  {
    path: "/orderManagement/duplicateCheck",
    name: "duplicateCheck",
    meta: {
      title: "查重工单",
    },
    component: () =>
      import("@/pages/orderManagement/createOrder/duplicateCheck.vue"),
  },
  {
    path: "/knowledgeBase/createInformation",
    name: "createInformation",
    meta: {
      title: "信息录入",
    },
    component: () =>
      import(
        "@/pages/knowledgeBase/informationCollection/CreateInformation.vue"
      ),
  },
  {
    path: "/knowledgeBase/detail/:knoId",
    name: "knoDetail",
    meta: {
      title: "信息详情",
    },
    component: () =>
      import("@/pages/knowledgeBase/informationCollection/Details.vue"),
  },
  /* end *** 12345热线工单系统 ********************************************************************/
];

/**
 * 错误页面
 */

const errorPage = [
  {
    path: "/403",
    name: "403",
    meta: {
      title: "403",
    },
    component: () => import("@/pages/system/error/403"),
  },
  {
    path: "/500",
    name: "500",
    meta: {
      title: "500",
    },
    component: () => import("@/pages/system/error/500"),
  },
  {
    path: "*",
    name: "404",
    meta: {
      title: "404",
    },
    component: () => import("@/pages/system/error/404"),
  },
];

// 导出需要显示菜单的
export const frameInRoutes = frameIn;

// 重新组织后导出
export default [...frameIn, ...frameOut, ...errorPage];
